module.exports = __webpack_public_path__ + "static/media/airtel.2dcb540a.png";